<a
  [class.contents]="contents()"
  [class.underline]="underline()"
  [href]="link()"
  [target]="target()">
  <ng-content />
</a>
